var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 391 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 199.806,
    cy: 191.515,
    r: 61.88,
    stroke: "url(#b)",
    strokeWidth: 0.477
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.807,
    cy: 191.514,
    r: 90.629,
    stroke: "url(#c)",
    strokeOpacity: 0.3,
    strokeWidth: 0.477
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.805,
    cy: 191.514,
    r: 121.432,
    stroke: "url(#d)",
    strokeOpacity: 0.8,
    strokeWidth: 0.477
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 199.805,
    cy: 191.514,
    r: 161.475,
    stroke: "url(#e)",
    strokeOpacity: 0.85,
    strokeWidth: 0.477
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.631 144.426c0-7.574 6.139-13.713 13.713-13.713s13.712 6.139 13.712 13.713-6.139 13.712-13.712 13.712c-7.574 0-13.713-6.139-13.713-13.712",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.344,
    cy: 144.426,
    r: 13.713,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    fill: "#019BC6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.759 138.689a7.19 7.19 0 0 0-10.428.96.088.088 0 0 0 .033.134c1.194.529 2.798.828 4.485.828 2.939 0 5.114-.87 5.917-1.799a.087.087 0 0 0-.007-.123m1.724 8.231h-.001c-2.171 0-4.229.582-5.797 1.639-1.05.709-1.776 1.578-2.096 2.482a.088.088 0 0 0 .066.116q.655.126 1.346.127a7.21 7.21 0 0 0 6.562-4.241.088.088 0 0 0-.08-.123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.752 139.757a.088.088 0 0 0-.133-.007c-1.221 1.287-3.818 2.12-6.766 2.12-1.942 0-3.808-.371-5.184-1.024a.09.09 0 0 0-.116.04c-.48.964-.75 2.05-.75 3.198a7.21 7.21 0 0 0 4.462 6.658c.047.019.1-.006.116-.054.4-1.184 1.3-2.296 2.602-3.174 1.772-1.196 4.081-1.854 6.5-1.854q.236 0 .468.008a.086.086 0 0 0 .089-.069 7.2 7.2 0 0 0-1.288-5.842"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.473 263.572c0-12.656 10.26-22.916 22.916-22.916s22.915 10.26 22.915 22.916-10.26 22.916-22.915 22.916c-12.657 0-22.916-10.26-22.916-22.916",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.389,
    cy: 263.572,
    r: 22.916,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    fill: "#FFA939"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.095 261.318-3.443 3.049c.13 1.939.74 3.814 1.777 5.458l4.574.443 1.874-2.579-1.434-5.284zm17.619 9.412-3.855.374-1.549 3.557a11.8 11.8 0 0 0 5.404-3.931m-6.596-3.377 1.383-5.095-4.113-2.799-4.113 2.799 1.383 5.095zm1.975 3.409-1.87-2.569h-5.672l-1.867 2.571 1.837 4.218a11.75 11.75 0 0 0 5.731 0zm-8.628 3.899-1.549-3.557-3.855-.374a11.8 11.8 0 0 0 5.404 3.931M41.7 256.912a11.7 11.7 0 0 0-2.067 6.353l2.902-2.57zm5.027 4.704 4.24-2.886v-3.739l-3.962-2.331a11.8 11.8 0 0 0-4.64 3.375l.99 4.487zm16.416 1.65a11.7 11.7 0 0 0-2.067-6.354l-.836 3.784zm-8.413-10.971a11.7 11.7 0 0 0-6.685 0l3.342 1.967zm-2.921 6.435 4.24 2.886 3.371-1.093.99-4.486a11.8 11.8 0 0 0-4.64-3.377l-3.961 2.331zm11.312 5.637-3.442-3.049-3.348 1.087-1.434 5.284 1.873 2.578 4.575-.442a11.7 11.7 0 0 0 1.776-5.458"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 347.765,
    cy: 260.304,
    r: 9.685,
    fill: "url(#j)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.764,
    cy: 260.304,
    r: 5.483,
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.045 69.822c0-9.944 8.061-18.006 18.005-18.006s18.006 8.062 18.006 18.006-8.062 18.005-18.006 18.005-18.005-8.061-18.005-18.005",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.05,
    cy: 69.822,
    r: 18.005,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    fill: "#FFA939"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m208.259 74.203-.49-1.146.702-.3a10 10 0 0 1-.56-2.763h-.77v-1.247h.77c.057-.953.247-1.88.56-2.762l-.702-.3.49-1.146.703.3a10.1 10.1 0 0 1 1.866-2.579 9.4 9.4 0 0 0-6.227-2.342 9.4 9.4 0 0 0-6.228 2.342 10.1 10.1 0 0 1 1.867 2.579l.702-.3.49 1.146-.702.3c.314.881.503 1.81.561 2.762h.769v1.247h-.769a10 10 0 0 1-.561 2.762l.702.3-.49 1.147-.702-.3a10.1 10.1 0 0 1-1.867 2.578 9.4 9.4 0 0 0 6.228 2.342 9.4 9.4 0 0 0 6.227-2.342 10.1 10.1 0 0 1-1.866-2.579z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71 63.14a8.8 8.8 0 0 0-1.595 2.192l.669.286-.49 1.146-.668-.286a9 9 0 0 0-.462 2.269h.723v1.246h-.723c.054.77.208 1.532.462 2.269l.668-.286.491 1.146-.67.286c.406.79.937 1.53 1.595 2.191a9.4 9.4 0 0 0 2.344-6.229 9.42 9.42 0 0 0-2.344-6.23m-13.293 9.982.491-1.146.668.286c.254-.736.409-1.5.462-2.269h-.723v-1.246h.723a8.8 8.8 0 0 0-.462-2.269l-.668.286-.491-1.146.67-.286a8.8 8.8 0 0 0-1.595-2.191 9.42 9.42 0 0 0-2.344 6.23c0 2.386.885 4.565 2.344 6.229a8.8 8.8 0 0 0 1.595-2.192z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.646 320.359c0-7.573 6.14-13.713 13.713-13.713 7.574 0 13.713 6.14 13.713 13.713 0 7.574-6.139 13.713-13.713 13.713s-13.713-6.139-13.713-13.713",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.359,
    cy: 320.359,
    r: 13.713,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.225 326.85c-1.921.28-3.483-.047-3.897-.461-.415-.414-.742-1.984-.457-3.912a18.1 18.1 0 0 0 4.354 4.373m4.252-12.979c1.928-.285 3.498.043 3.913.457.413.413.74 1.976.46 3.897-1.171-1.665-2.635-3.123-4.373-4.354m-1.289.27a10.1 10.1 0 0 0-4.447 2.598 10.1 10.1 0 0 0-2.598 4.447c1.44 2.25 3.247 4.059 5.38 5.39a10.13 10.13 0 0 0 4.454-2.601 10.1 10.1 0 0 0 2.6-4.453c-1.33-2.134-3.139-3.941-5.389-5.381m.361 2.966q-.258.156-.511.327l.347.347a.354.354 0 0 1-.5.5l-.432-.432q-.375.281-.734.592l.502.503a.354.354 0 0 1-.5.5l-.521-.521c-.099.096-.153.124-.649.678l.508.507a.354.354 0 1 1-.501.5l-.463-.464q-.3.374-.565.762l.365.365a.354.354 0 0 1-.5.5l-.256-.256c-.105.176-.213.351-.308.531a.354.354 0 0 1-.625-.33q.194-.364.416-.718l-.39-.391a.354.354 0 0 1 .5-.5l.289.289q.27-.386.571-.756l-.197-.196a.354.354 0 1 1 .5-.501l.157.157c.527-.585.535-.568.649-.678l-.142-.142a.354.354 0 0 1 .5-.5l.159.159q.358-.313.73-.596l-.226-.226a.354.354 0 0 1 .5-.5l.305.304q.327-.223.662-.422a.353.353 0 1 1 .36.608",
    fill: "#FFA939"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.664 169.564c0-8.816 7.147-15.962 15.962-15.962 8.816 0 15.962 7.146 15.962 15.962s-7.146 15.962-15.962 15.962-15.962-7.147-15.962-15.962",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.628,
    cy: 169.564,
    r: 15.962,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    fill: "#FFA939"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.228 160.785c-4.61 0-8.38 3.771-8.38 8.38s3.77 8.38 8.38 8.38c4.609 0 8.38-3.771 8.38-8.38s-3.771-8.38-8.38-8.38m0 15.084c-3.687 0-6.704-3.017-6.704-6.704s3.016-6.704 6.704-6.704 6.704 3.017 6.704 6.704-3.017 6.704-6.704 6.704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.227 164.137a5.04 5.04 0 0 0-5.028 5.028c0 2.765 2.263 5.028 5.028 5.028a5.043 5.043 0 0 0 5.028-5.028 5.04 5.04 0 0 0-5.028-5.028m0 8.38a3.36 3.36 0 0 1-3.352-3.352 3.36 3.36 0 0 1 3.352-3.352 3.36 3.36 0 0 1 3.352 3.352 3.36 3.36 0 0 1-3.352 3.352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.229 170.84a1.676 1.676 0 1 0 0-3.352 1.676 1.676 0 0 0 0 3.352"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.508 151.562c-2.878-10.862 3.594-22 14.456-24.878s22 3.594 24.878 14.456-3.594 22-14.456 24.878-22-3.594-24.878-14.456",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.175,
    cy: 146.351,
    r: 20.346,
    transform: "rotate(-14.84 358.175 146.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    fill: "#FFA939"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.328 136.444a10.667 10.667 0 0 0-14.591 5.339.13.13 0 0 0 .099.179c1.913.306 4.327.125 6.746-.516 4.215-1.117 7.005-3.191 7.804-4.828a.13.13 0 0 0-.058-.174m5.601 11.15h-.002c-3.113.825-5.845 2.443-7.691 4.554-1.237 1.416-1.948 2.938-2.063 4.356a.13.13 0 0 0 .139.142 10.7 10.7 0 0 0 1.978-.33c4.181-1.108 7.128-4.563 7.8-8.575a.13.13 0 0 0-.161-.147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.154 137.6a.128.128 0 0 0-.193.039c-1.263 2.311-4.671 4.492-8.899 5.612-2.785.738-5.602.915-7.824.502a.13.13 0 0 0-.152.101 10.6 10.6 0 0 0 .14 4.871c1.14 4.304 4.767 7.3 8.929 7.854a.13.13 0 0 0 .146-.121c.124-1.851.992-3.787 2.526-5.541 2.088-2.389 5.149-4.21 8.618-5.13q.338-.088.675-.166a.13.13 0 0 0 .101-.132 10.7 10.7 0 0 0-.345-2.235 10.63 10.63 0 0 0-3.722-5.654"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.303 66.482c0-12.431 10.078-22.51 22.509-22.51s22.51 10.078 22.51 22.51-10.078 22.51-22.51 22.51c-12.431 0-22.509-10.078-22.509-22.51",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.812,
    cy: 66.482,
    r: 22.509,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.31 77.135c-3.154.46-5.718-.076-6.397-.755-.681-.68-1.218-3.257-.751-6.423 2.021 2.854 4.415 5.256 7.148 7.178m6.977-21.303c3.166-.467 5.743.07 6.424.75.678.68 1.215 3.243.755 6.398-1.923-2.733-4.324-5.127-7.179-7.148m-2.117.445a16.6 16.6 0 0 0-7.3 4.265 16.64 16.64 0 0 0-4.265 7.3c2.365 3.693 5.332 6.664 8.833 8.847a16.6 16.6 0 0 0 7.31-4.268 16.6 16.6 0 0 0 4.269-7.31c-2.183-3.502-5.154-6.469-8.847-8.834m.593 4.87a20 20 0 0 0-.839.536l.57.57a.58.58 0 0 1-.821.821l-.709-.71c-.41.309-.813.63-1.205.973l.825.825a.58.58 0 1 1-.821.82l-.856-.855c-.162.158-.251.204-1.065 1.113l.833.832a.58.58 0 1 1-.821.821l-.761-.761a20 20 0 0 0-.927 1.25l.599.6a.58.58 0 1 1-.821.821l-.421-.42c-.172.288-.348.576-.504.87a.58.58 0 0 1-1.027-.54c.211-.4.443-.791.683-1.18l-.64-.641a.58.58 0 1 1 .821-.821l.475.475q.442-.633.936-1.241l-.323-.323a.58.58 0 0 1 .821-.821l.257.257c.866-.96.879-.932 1.066-1.113l-.233-.233a.58.58 0 1 1 .821-.82l.261.26q.586-.513 1.198-.979l-.371-.37a.58.58 0 0 1 .821-.821l.5.5q.537-.367 1.087-.694a.58.58 0 1 1 .591 1",
    fill: "#019BC6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.47 69.649c0-16.048 13.01-29.057 29.058-29.057 16.047 0 29.056 13.009 29.056 29.057s-13.009 29.056-29.056 29.056S64.47 85.696 64.47 69.65",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.528,
    cy: 69.649,
    r: 29.057,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    fill: "#019BC6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.847 58.823a2.56 2.56 0 0 0-.728-1.007c-1.09-.903-3.111-.753-3.72-.683a15.3 15.3 0 0 0-6.014 9.383c1.94-3.705 5.772-6.56 10.462-7.693m3.84-4.591c-2.17.096-4.223.646-6.068 1.558.784.113 1.646.387 2.365.983a3.93 3.93 0 0 1 1.211 1.776 19 19 0 0 1 2.492-.247zm8.035 28.633c.164-.08 4.125-2.606 2.62-8.473-.427-1.667-1.656-3.13-2.928-4.686-1.935-2.368-4.129-5.052-4.184-9.07a7 7 0 0 1 .029-.759 18 18 0 0 0-2.218-.219v25.085c2.414-.106 4.628-.883 6.681-1.878m-6.681-28.633v4.07q1.274.046 2.492.247.375-1.081 1.21-1.776c.72-.596 1.582-.87 2.366-.983a15.2 15.2 0 0 0-6.068-1.558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.337 72.214c.248 2.764 1.717 5.212 3.46 7.234-.312-1.367-.339-3.147.281-5.413.53-1.937 1.82-3.515 3.186-5.186 1.883-2.304 3.83-4.686 3.878-8.23a6 6 0 0 0-.01-.47c-6.218 1.512-11.297 6.469-10.795 12.064m23.974-15.093c-.74-.072-2.669-.165-3.707.7a2.56 2.56 0 0 0-.723 1.003c4.69 1.134 8.521 3.988 10.462 7.693a15.3 15.3 0 0 0-6.032-9.395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.39 72.212c.502-5.596-4.577-10.553-10.794-12.065q-.015.226-.011.47c.048 3.544 1.995 5.926 3.878 8.23 1.366 1.67 2.656 3.249 3.186 5.186.62 2.266.593 4.046.281 5.413 1.743-2.022 3.212-4.47 3.46-7.234M85.892 82.865c2.06.983 4.381 1.772 6.795 1.878V59.658q-1.134.043-2.218.22.033.364.029.759c-.056 4.017-2.249 6.7-4.184 9.069-1.273 1.556-2.494 3.021-2.928 4.686-1.592 6.093 2.465 8.453 2.506 8.473"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.52 346.076c0-12.204 9.893-22.097 22.097-22.097s22.097 9.893 22.097 22.097-9.893 22.097-22.097 22.097-22.097-9.893-22.097-22.097",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.617,
    cy: 346.076,
    r: 22.097,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    fill: "#019BC6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.027 337.96c-2.258-1.129-5.244-1.751-8.409-1.751-3.164 0-6.15.622-8.408 1.751-2.415 1.207-3.745 2.87-3.745 4.682s1.33 3.475 3.745 4.682c2.258 1.129 5.244 1.751 8.408 1.751 3.165 0 6.151-.622 8.409-1.751 2.415-1.207 3.745-2.87 3.745-4.682s-1.33-3.475-3.745-4.682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.662 348.598c-2.452 1.226-5.664 1.901-9.046 1.901s-6.593-.675-9.045-1.901c-1.303-.651-2.347-1.432-3.108-2.323v3.232c0 1.812 1.33 3.475 3.745 4.682 2.258 1.129 5.244 1.751 8.408 1.751 3.165 0 6.151-.622 8.409-1.751 2.415-1.207 3.745-2.87 3.745-4.682v-3.232c-.761.891-1.805 1.672-3.108 2.323"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#x)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.324,
    y: 97.018,
    width: 188.716,
    height: 188.716,
    rx: 94.358,
    fill: "#E6F9FF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.542 142.845-16.691 4.472c-.425.114-.618.77-.432 1.466l1.07 3.991c.186.696.682 1.167 1.106 1.054l16.691-4.473c.425-.113.618-.77.432-1.465l-1.07-3.991c-.186-.696-.682-1.168-1.106-1.054m-21.512 5.763-17.286 4.632c-.44.118-.646.777-.459 1.473l1.069 3.991c.187.695.694 1.164 1.134 1.046l17.287-4.632c.44-.118.645-.777.459-1.473l-1.07-3.991c-.186-.696-.694-1.164-1.134-1.046m-22.134 5.931-17.287 4.632c-.44.118-.645.778-.459 1.473l1.069 3.992c.187.695.694 1.163 1.134 1.046l17.287-4.632c.44-.118.645-.778.459-1.473l-1.069-3.992c-.187-.695-.694-1.163-1.134-1.046m-22.079 5.917-16.095 4.312c-.41.11-.59.763-.404 1.458l1.069 3.992c.187.695.67 1.17 1.079 1.06l16.095-4.312c.409-.11.59-.763.404-1.458l-1.069-3.992c-.187-.695-.67-1.17-1.079-1.06",
    fill: "#CCF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.246 129.98-64.141 17.187a7.634 7.634 0 0 0-5.399 9.35l27.575 102.911a7.634 7.634 0 0 0 9.351 5.398l79.172-21.214a7.635 7.635 0 0 0 5.399-9.35l-24.37-90.95c-1.092-4.073-23.515-14.423-27.587-13.332",
    fill: "#fff",
    stroke: "#34D2FE",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.178 156.151-16.095 4.312c-.409.11-.59.763-.404 1.459l1.07 3.991c.186.695.669 1.17 1.079 1.061l16.094-4.313c.41-.11.591-.762.404-1.458l-1.069-3.991c-.187-.696-.67-1.171-1.079-1.061",
    fill: "#CCF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.973 143.624-19.856 5.32a2.695 2.695 0 0 1-3.302-1.906l-4.536-16.927",
    stroke: "#34D2FE",
    strokeWidth: 0.539
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.532 163.279-16.691 4.472c-.424.114-.618.77-.431 1.465l1.069 3.992c.187.695.682 1.167 1.107 1.053l16.69-4.472c.425-.114.618-.77.432-1.466l-1.07-3.991c-.186-.695-.681-1.167-1.106-1.053m-21.511 5.762-17.287 4.632c-.44.118-.645.778-.459 1.473l1.069 3.991c.187.696.694 1.164 1.134 1.047l17.287-4.632c.44-.118.645-.778.459-1.473l-1.069-3.992c-.187-.695-.694-1.164-1.134-1.046m-22.135 5.932-17.287 4.632c-.44.118-.645.777-.459 1.473l1.07 3.991c.186.696.694 1.164 1.134 1.046l17.286-4.632c.44-.118.646-.777.459-1.473l-1.069-3.991c-.187-.696-.694-1.164-1.134-1.046m-22.079 5.916-16.095 4.313c-.409.109-.59.762-.404 1.458l1.07 3.991c.186.696.669 1.171 1.079 1.061l16.094-4.313c.41-.109.591-.762.404-1.458l-1.069-3.991c-.187-.696-.67-1.171-1.079-1.061m69.213-4.589-16.69 4.472c-.425.114-.618.77-.432 1.466l1.069 3.991c.187.696.682 1.167 1.107 1.054l16.691-4.473c.424-.113.617-.769.431-1.465l-1.069-3.991c-.187-.696-.682-1.168-1.107-1.054m-21.511 5.763-17.287 4.632c-.44.118-.645.777-.459 1.473l1.07 3.991c.186.696.694 1.164 1.134 1.046l17.286-4.632c.44-.118.646-.777.459-1.473l-1.069-3.991c-.187-.696-.694-1.164-1.134-1.046m-22.133 5.931-17.287 4.632c-.439.118-.645.778-.459 1.473l1.07 3.992c.186.695.694 1.164 1.134 1.046l17.287-4.632c.439-.118.645-.778.459-1.473l-1.07-3.991c-.186-.696-.694-1.164-1.134-1.047m-22.081 5.917-16.095 4.312c-.409.11-.59.763-.404 1.458l1.07 3.992c.186.695.669 1.17 1.079 1.06l16.094-4.312c.41-.11.591-.763.404-1.458l-1.069-3.992c-.186-.695-.669-1.17-1.079-1.06m69.215-4.591-16.69 4.472c-.425.114-.618.77-.432 1.465l1.07 3.992c.186.695.681 1.167 1.106 1.053l16.691-4.472c.424-.114.618-.77.431-1.466l-1.069-3.991c-.187-.695-.682-1.167-1.107-1.053m-21.513 5.762-17.287 4.632c-.439.118-.645.778-.458 1.473l1.069 3.992c.186.695.694 1.163 1.134 1.046l17.287-4.632c.44-.118.645-.778.459-1.473l-1.07-3.992c-.186-.695-.694-1.163-1.134-1.046m-22.135 5.932-17.286 4.632c-.44.118-.646.777-.459 1.473l1.069 3.991c.187.696.694 1.164 1.134 1.046l17.287-4.632c.44-.118.645-.777.459-1.473l-1.07-3.991c-.186-.696-.694-1.164-1.134-1.046m-22.079 5.916-16.094 4.313c-.41.109-.591.762-.404 1.458l1.069 3.991c.187.696.67 1.171 1.079 1.061l16.095-4.313c.409-.109.59-.762.404-1.458l-1.07-3.991c-.186-.696-.669-1.171-1.079-1.061m69.216-4.589-16.691 4.472c-.425.114-.618.77-.431 1.466l1.069 3.991c.186.696.682 1.167 1.106 1.054l16.691-4.473c.425-.113.618-.769.432-1.465l-1.07-3.991c-.186-.696-.682-1.168-1.106-1.054m-21.513 5.763-17.287 4.632c-.44.118-.646.777-.459 1.473l1.069 3.991c.187.696.694 1.164 1.134 1.046l17.287-4.632c.44-.118.645-.777.459-1.473l-1.07-3.991c-.186-.696-.694-1.164-1.133-1.046m-22.135 5.931-17.287 4.632c-.44.118-.645.778-.459 1.473l1.07 3.992c.186.695.694 1.164 1.133 1.046l17.287-4.632c.44-.118.646-.778.459-1.473l-1.069-3.991c-.187-.696-.694-1.164-1.134-1.047m-22.079 5.917-16.095 4.312c-.409.11-.59.763-.404 1.458l1.069 3.992c.187.695.67 1.17 1.079 1.06l16.095-4.312c.41-.11.59-.763.404-1.458l-1.069-3.992c-.187-.695-.67-1.17-1.079-1.06m69.215-4.591-16.691 4.472c-.424.114-.618.77-.431 1.465l1.069 3.992c.187.695.682 1.167 1.107 1.053l16.69-4.472c.425-.114.618-.77.432-1.465l-1.07-3.992c-.186-.695-.681-1.167-1.106-1.053m-21.511 5.762-17.287 4.632c-.44.118-.645.778-.459 1.473l1.07 3.992c.186.695.694 1.163 1.133 1.046l17.287-4.632c.44-.118.646-.778.459-1.473l-1.069-3.992c-.187-.695-.694-1.163-1.134-1.046m-22.135 5.932-17.287 4.632c-.44.118-.645.777-.459 1.473l1.07 3.991c.186.696.694 1.164 1.134 1.046l17.286-4.632c.44-.118.646-.777.459-1.473l-1.069-3.991c-.186-.696-.694-1.164-1.134-1.046m-22.079 5.916-16.095 4.313c-.409.109-.59.762-.404 1.458l1.07 3.991c.186.696.669 1.171 1.079 1.061l16.094-4.313c.41-.109.591-.762.404-1.458l-1.069-3.991c-.187-.696-.67-1.171-1.079-1.061m69.213-4.589-16.69 4.473c-.425.113-.618.769-.432 1.465l1.07 3.991c.186.696.681 1.168 1.106 1.054l16.691-4.473c.424-.113.618-.769.431-1.465l-1.069-3.991c-.187-.696-.682-1.168-1.107-1.054m-21.511 5.763-17.287 4.632c-.44.118-.645.777-.459 1.473l1.07 3.991c.186.696.694 1.164 1.134 1.046l17.286-4.632c.44-.118.646-.777.459-1.473l-1.069-3.991c-.186-.696-.694-1.164-1.134-1.046m-22.135 5.932-17.286 4.631c-.44.118-.646.778-.459 1.473l1.069 3.992c.186.695.694 1.164 1.134 1.046l17.287-4.632c.44-.118.645-.778.459-1.473l-1.07-3.991c-.186-.696-.694-1.164-1.134-1.046m-22.079 5.916-16.094 4.312c-.41.11-.591.763-.404 1.458l1.069 3.992c.186.695.669 1.17 1.079 1.06l16.095-4.312c.409-.11.59-.763.404-1.458l-1.07-3.992c-.186-.695-.669-1.17-1.079-1.06",
    fill: "#CCF4FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14,
    filter: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m213.796 131.239-64.751 15.701c-3.518.942-5.564 4.713-4.57 8.422l25.112 93.718c.994 3.709 4.651 5.952 8.169 5.01l68.379-18.323c3.518-.942 5.563-4.713 4.57-8.422l-24.636-91.442c-.994-3.709-8.756-5.606-12.273-4.664",
    fill: "#017798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.796 131.239-64.751 15.701c-3.518.942-5.564 4.713-4.57 8.422l25.112 93.718c.994 3.709 4.651 5.952 8.169 5.01l68.379-18.323c3.518-.942 5.563-4.713 4.57-8.422l-24.636-91.442c-.994-3.709-8.756-5.606-12.273-4.664",
    stroke: "#34D2FE",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m198.744 122.566-64.141 17.187a7.633 7.633 0 0 0-5.398 9.35l27.574 102.911a7.636 7.636 0 0 0 9.351 5.398l79.172-21.214a7.635 7.635 0 0 0 5.399-9.35l-24.37-90.95c-1.092-4.073-23.515-14.423-27.587-13.332",
    fill: "#fff",
    stroke: "#34D2FE",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.676 148.737-16.095 4.312c-.409.11-.59.763-.404 1.458l1.07 3.992c.186.695.669 1.17 1.079 1.061l16.094-4.313c.41-.11.591-.763.404-1.458l-1.069-3.991c-.187-.696-.67-1.171-1.079-1.061",
    fill: "#CCF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.473 136.21-19.856 5.32a2.696 2.696 0 0 1-3.302-1.906l-4.536-16.927",
    stroke: "#34D2FE",
    strokeWidth: 0.539
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.032 155.865-16.691 4.472c-.424.114-.618.77-.431 1.465l1.069 3.992c.187.695.682 1.167 1.107 1.053l16.69-4.472c.425-.114.618-.77.432-1.466l-1.07-3.991c-.186-.695-.681-1.167-1.106-1.053m-21.513 5.762-17.287 4.632c-.44.118-.645.778-.459 1.473l1.069 3.991c.187.696.695 1.164 1.134 1.046l17.287-4.632c.44-.117.645-.777.459-1.472l-1.069-3.992c-.187-.695-.694-1.164-1.134-1.046m-22.135 5.932-17.287 4.632c-.44.118-.645.777-.459 1.473l1.07 3.991c.186.696.694 1.164 1.134 1.046l17.286-4.632c.44-.118.646-.777.459-1.473l-1.069-3.991c-.187-.696-.694-1.164-1.134-1.046m-22.079 5.916-16.095 4.313c-.409.109-.59.762-.404 1.458l1.07 3.991c.186.696.669 1.171 1.079 1.061l16.094-4.313c.41-.109.591-.762.404-1.458l-1.069-3.991c-.187-.696-.67-1.171-1.079-1.061m62.354-29.741-16.691 4.472c-.425.114-.618.77-.431 1.466l1.069 3.991c.187.695.682 1.167 1.107 1.053l16.69-4.472c.425-.114.618-.77.432-1.465l-1.07-3.992c-.186-.695-.681-1.167-1.106-1.053m-21.511 5.762-17.287 4.632c-.44.118-.645.778-.459 1.473l1.069 3.992c.187.695.694 1.163 1.134 1.046l17.287-4.632c.44-.118.645-.778.459-1.473l-1.069-3.992c-.187-.695-.695-1.163-1.134-1.046m-22.135 5.932-17.287 4.632c-.44.118-.645.777-.459 1.473l1.07 3.991c.186.696.694 1.164 1.134 1.046l17.286-4.632c.44-.118.646-.777.459-1.473l-1.069-3.991c-.187-.695-.694-1.164-1.134-1.046m-22.079 5.916-16.095 4.313c-.409.11-.59.762-.404 1.458l1.07 3.991c.186.696.669 1.171 1.079 1.061l16.094-4.313c.41-.109.591-.762.404-1.458l-1.069-3.991c-.187-.696-.67-1.17-1.079-1.061m72.584 7.542-16.69 4.472c-.425.114-.618.77-.432 1.466l1.07 3.991c.186.696.681 1.167 1.106 1.054l16.691-4.473c.424-.113.617-.77.431-1.465l-1.069-3.991c-.187-.696-.682-1.168-1.107-1.054m-21.511 5.763-17.287 4.632c-.44.118-.645.777-.459 1.473l1.07 3.991c.186.695.694 1.164 1.134 1.046l17.286-4.632c.44-.118.646-.777.459-1.473l-1.069-3.991c-.186-.696-.694-1.164-1.134-1.046m-22.135 5.931-17.287 4.632c-.439.118-.645.778-.458 1.473l1.069 3.992c.186.695.694 1.163 1.134 1.046l17.287-4.632c.44-.118.645-.778.459-1.473l-1.07-3.992c-.186-.695-.694-1.163-1.134-1.046m-22.079 5.917-16.094 4.312c-.41.11-.591.763-.405 1.458l1.07 3.992c.186.695.669 1.17 1.079 1.06l16.094-4.312c.41-.11.591-.763.405-1.458l-1.07-3.992c-.186-.695-.669-1.17-1.079-1.06m69.213-4.591-16.69 4.472c-.425.114-.618.77-.432 1.465l1.07 3.992c.186.695.682 1.167 1.106 1.053l16.691-4.472c.425-.114.618-.77.431-1.466l-1.069-3.991c-.186-.695-.682-1.167-1.107-1.053m-21.511 5.762-17.286 4.632c-.44.118-.646.778-.459 1.473l1.069 3.991c.186.696.694 1.164 1.134 1.046l17.287-4.631c.44-.118.645-.778.459-1.473l-1.07-3.992c-.186-.695-.694-1.164-1.134-1.046m-22.134 5.932-17.287 4.632c-.44.118-.646.777-.459 1.473l1.069 3.991c.187.696.694 1.164 1.134 1.046l17.287-4.632c.44-.118.645-.777.459-1.473l-1.07-3.991c-.186-.696-.694-1.164-1.133-1.046m-22.08 5.916-16.094 4.313c-.41.109-.591.762-.404 1.458l1.069 3.991c.187.696.67 1.171 1.079 1.061l16.095-4.313c.409-.109.59-.762.404-1.458l-1.07-3.991c-.186-.696-.669-1.171-1.079-1.061m69.214-4.589-16.691 4.472c-.425.114-.618.77-.431 1.466l1.069 3.991c.186.696.682 1.167 1.107 1.054l16.69-4.473c.425-.113.618-.77.432-1.465l-1.07-3.991c-.186-.696-.682-1.168-1.106-1.054m-21.511 5.763-17.287 4.632c-.44.118-.646.777-.459 1.473l1.069 3.991c.187.695.694 1.164 1.134 1.046l17.287-4.632c.44-.118.645-.777.459-1.473l-1.07-3.991c-.186-.696-.694-1.164-1.133-1.046m-22.135 5.931-17.287 4.632c-.44.118-.645.778-.459 1.473l1.07 3.992c.186.695.694 1.163 1.133 1.046l17.287-4.632c.44-.118.646-.778.459-1.473l-1.069-3.992c-.187-.695-.694-1.163-1.134-1.046m-22.079 5.917-16.095 4.312c-.409.11-.59.763-.404 1.458l1.07 3.992c.186.695.669 1.17 1.079 1.06l16.094-4.312c.41-.11.59-.763.404-1.458l-1.069-3.992c-.187-.695-.67-1.17-1.079-1.06m69.217-4.591-16.691 4.472c-.424.114-.618.77-.431 1.465l1.069 3.992c.187.695.682 1.167 1.107 1.053l16.69-4.472c.425-.114.618-.77.432-1.466l-1.07-3.991c-.186-.695-.681-1.167-1.106-1.053m-21.513 5.762-17.287 4.632c-.44.118-.645.778-.459 1.473l1.07 3.991c.186.696.694 1.164 1.133 1.046l17.287-4.631c.44-.118.646-.778.459-1.473l-1.069-3.992c-.187-.695-.694-1.164-1.134-1.046m-22.133 5.932-17.287 4.632c-.44.118-.645.777-.459 1.473l1.07 3.991c.186.696.694 1.164 1.134 1.046l17.286-4.632c.44-.118.646-.777.459-1.473l-1.069-3.991c-.186-.696-.694-1.164-1.134-1.046m-22.081 5.916-16.095 4.313c-.409.109-.59.762-.404 1.458l1.07 3.991c.186.696.669 1.171 1.079 1.061l16.094-4.313c.41-.109.591-.762.404-1.458l-1.069-3.991c-.187-.696-.67-1.171-1.079-1.061m69.215-4.589-16.69 4.472c-.425.114-.618.77-.432 1.466l1.07 3.991c.186.696.681 1.167 1.106 1.054l16.691-4.473c.424-.113.618-.77.431-1.465l-1.069-3.991c-.187-.696-.682-1.168-1.107-1.054m-21.513 5.763-17.287 4.632c-.44.118-.645.777-.459 1.473l1.07 3.991c.186.696.694 1.164 1.134 1.046l17.286-4.632c.44-.118.646-.777.459-1.473l-1.069-3.991c-.186-.696-.694-1.164-1.134-1.046m-22.135 5.931-17.286 4.632c-.44.118-.646.778-.459 1.473l1.069 3.992c.186.695.694 1.163 1.134 1.046l17.287-4.632c.44-.118.645-.778.459-1.473l-1.07-3.992c-.186-.695-.694-1.163-1.134-1.046m-22.079 5.917-16.094 4.312c-.41.11-.591.763-.404 1.458l1.069 3.992c.186.695.669 1.17 1.079 1.06l16.095-4.312c.409-.11.59-.763.404-1.458l-1.07-3.992c-.186-.695-.669-1.17-1.079-1.06",
    fill: "#CCF4FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.814,
    y: 187.828,
    width: 48.794,
    height: 48.794,
    rx: 24.397,
    transform: "rotate(-15 119.814 187.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m119.814 187.828 47.131-12.629 12.63 47.132-47.132 12.628z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149.854 205.67 5.433 3.136-1.046 1.812-2.341-1.352 1.512 5.641-2.02.541-1.512-5.643-1.351 2.343-1.812-1.046zm-2.865-10.692a7.324 7.324 0 0 1 8.7 4.374 5.751 5.751 0 0 1 1.956 11.149l-.546-2.034a3.65 3.65 0 0 0 1.971-2.032c.177-.452.262-.936.251-1.422a3.665 3.665 0 0 0-3.812-3.567c-.486.02-.963.137-1.403.344a5.23 5.23 0 0 0-8.618-3.712 5.22 5.22 0 0 0-1.829 4.119c.022.78.218 1.544.573 2.238a3.66 3.66 0 0 0 .557 7.298l.19-.018.545 2.034a5.75 5.75 0 0 1-6.386-3.694 5.75 5.75 0 0 1-.007-3.924 5.75 5.75 0 0 1 2.511-3.015 7.32 7.32 0 0 1 5.347-8.138",
    fill: "#34D2FE"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M117.181 212.27s-6.85 8.036 1.135 14.89c-7.985-6.854-14.89 1.135-14.89 1.135s6.851-8.036-1.135-14.89c7.986 6.854 14.89-1.135 14.89-1.135m175.91-62.682s-6.85 8.036 1.136 14.89c-7.986-6.854-14.89 1.135-14.89 1.135s6.85-8.036-1.136-14.89c7.986 6.854 14.89-1.135 14.89-1.135",
    fill: "#fff",
    stroke: "#34D2FE",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 207.365,
    y: 122.58,
    width: 59.957,
    height: 59.957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.909025 0 0 0 0 0.942831 0 0 0 0 0.966496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 1.291,
    y: 227.065,
    width: 100.195,
    height: 100.195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.591
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.591
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.909025 0 0 0 0 0.942831 0 0 0 0 0.966496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 165.688,
    y: 41.138,
    width: 78.724,
    height: 78.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.678
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.678
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.909025 0 0 0 0 0.942831 0 0 0 0 0.966496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 266.381,
    y: 298.514,
    width: 59.957,
    height: 59.957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.133
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.909025 0 0 0 0 0.942831 0 0 0 0 0.966496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 45.731,
    y: 144.135,
    width: 69.793,
    height: 69.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.467
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.467
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.909025 0 0 0 0 0.942831 0 0 0 0 0.966496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 309.164,
    y: 109.406,
    width: 98.022,
    height: 98.022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.067
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.909025 0 0 0 0 0.942831 0 0 0 0 0.966496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    x: 251.603,
    y: 30.623,
    width: 98.419,
    height: 98.419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.35
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.909025 0 0 0 0 0.942831 0 0 0 0 0.966496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    x: 30.005,
    y: 23.359,
    width: 127.045,
    height: 127.045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.233
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.233
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.909025 0 0 0 0 0.942831 0 0 0 0 0.966496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "v",
    x: 112.309,
    y: 310.873,
    width: 96.617,
    height: 96.617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.105
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.105
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.909025 0 0 0 0 0.942831 0 0 0 0 0.966496 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "x",
    x: 75.037,
    y: 83.538,
    width: 246.444,
    height: 242.636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13.48
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.48
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0738022 0 0 0 0 0.549438 0 0 0 0 0.675872 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "y",
    x: 116.97,
    y: 103.746,
    width: 161.239,
    height: 177.813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.48,
    result: "effect1_foregroundBlur_4067_4515"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "z",
    x: 103.639,
    y: 167.111,
    width: 92.111,
    height: 92.111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.088
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.088
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.137576 0 0 0 0 0.491582 0 0 0 0 0.555946 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4067_4515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4067_4515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.719 0h389.564v399H.719z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M229.801 136.885h14.398v14.398h-14.398z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.783 250.969H63.99v25.207H38.783z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M195.148 59.918h18.906v18.906h-18.906z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.848 160.785h16.76v16.76h-16.76z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m344.49 138.4 20.65-5.472 5.472 20.65-20.65 5.472z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.111 54.232h30.51v30.51h-30.51z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M148.463 333.922h24.307v24.307h-24.307z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.814,
    y: 187.828,
    width: 48.794,
    height: 48.794,
    rx: 24.397,
    transform: "rotate(-15 119.814 187.828)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m132.621 195.221 26.932-7.216 7.216 26.932-26.932 7.216z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 192.59,
    y1: 216.927,
    x2: 267.092,
    y2: 212.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0399F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 189.252,
    y1: 228.687,
    x2: 298.233,
    y2: 221.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0399F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 185.671,
    y1: 241.288,
    x2: 331.596,
    y2: 232.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0399F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 181.02,
    y1: 257.67,
    x2: 374.971,
    y2: 245.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0399F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 346.64,
    y1: 264.266,
    x2: 358.255,
    y2: 263.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0399F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 347.128,
    y1: 262.547,
    x2: 353.704,
    y2: 262.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0399F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7EB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadData);
export default __webpack_public_path__ + "static/media/upload-data.e36a029e.svg";
export { ForwardRef as ReactComponent };